import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ActivatedRoute } from '@angular/router';
import { LogDetailsModalComponent } from 'src/app/shared/components/log-details-modal/log-details-modal.component';
import { TableComponent } from 'src/app/shared/components/table/table.component';
import { MenuFunctionalityEnum } from 'src/app/shared/menu/menu.functionality.enum';
import { MenuModuleEnum } from 'src/app/shared/menu/menu.module.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { RequestLogService } from 'src/app/shared/services/API/integration-fast-medic/request-log.service';
import { DeliverySituationModel } from 'src/app/shared/services/models/integration-fast-medic/delivery-situation.model';
import { TicketTotemRequestModel } from 'src/app/shared/services/models/integration-fast-medic/ticket-totem-request.model';
import { TriageRequestModel } from 'src/app/shared/services/models/integration-fast-medic/triage-request.model';

@Component({
  selector: 'app-log-fast-medic',
  templateUrl: './log-fast-medic.component.html',
  styleUrls: ['./log-fast-medic.component.css']
})
export class LogFastMedicComponent implements OnInit {
  constructor(private alertService: AlertService,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private requestLogService: RequestLogService) { }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(TableComponent) tableComponent!: TableComponent;

  menuModuleEnum: MenuModuleEnum = MenuModuleEnum.support;
  menuFunctionalityEnum: MenuFunctionalityEnum = MenuFunctionalityEnum.log_batch_list;

  isLoading: boolean = true;
  
  fullListSizeTriage: number = 0;
  listTriageLog: any[] = [];

  fullListSizeTicket: number = 0;
  listTicketLog: any[] = [];
  
  listDeliverySituation: DeliverySituationModel[] = [];

  idHealthUnit: number = null;
  idDeliverySituation: number = null;

  searchText: string = null;
  selectedPeriod: Date = null;

  columnsTriage: { header: string, field: string, isAction?: boolean, width?: string }[] = [
    { header: 'ID Unidade de Saúde', field: 'idHealthUnit', width: '10%' },
    { header: 'Log Solicitante', field: 'requestBody', width: '10%' },
    { header: 'Log Resposta', field: 'xmlResponse', width: '10%' },
    { header: 'ID Episódio', field: 'idEpisode', width: '7%' },
    { header: 'CNS', field: 'cnesProvider', width: '7%' },
    { header: 'Contagem de processos', field: 'proccessCount', width: '7%' },
    { header: 'Guia de entrega', field: 'deliveryGuid', width: '7%' },
    { header: 'Data de inclusão', field: 'datetimeInclusion', width: '10%' },
    { header: 'Data da verificação', field: 'datetimeVerification', width: '10%' },
    { header: 'Ações', field: 'actions', isAction: true, width: '2%' }
  ];

  columnsTicket: { header: string, field: string, isAction?: boolean, width?: string }[] = [
    { header: 'ID Unidade de Saúde', field: 'idHealthUnit', width: '10%' },
    { header: 'Log Solicitante', field: 'requestBody', width: '10%' },
    { header: 'Log Resposta', field: 'xmlResponse', width: '10%' },
    { header: 'ID Episódio', field: 'idEpisode', width: '7%' },
    { header: 'CNS', field: 'cnesProvider', width: '7%' },
    { header: 'Contagem de processos', field: 'proccessCount', width: '7%' },
    { header: 'Guia de entrega', field: 'deliveryGuid', width: '7%' },
    { header: 'Data de inclusão', field: 'datetimeInclusion', width: '10%' },
    { header: 'Data da verificação', field: 'datetimeVerification', width: '10%' },
    { header: 'Ações', field: 'actions', isAction: true, width: '2%' }
  ];

  ngOnInit(): void {
    if (this.activatedRoute.snapshot.paramMap.get('idHealthUnit'))
      this.idHealthUnit = parseInt(this.activatedRoute.snapshot.paramMap.get('idHealthUnit'));

    this.search(0);
  }

  changePage(event: PageEvent) {
    this.search(event.pageIndex);
  }

  buttonSearch() {
    if (this.isLoading)
      return;

    this.paginator.firstPage();
    this.search(0);
  }

  private timeoutKeySearch: any = null;

  onKeySearch(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {
      if (event.keyCode != 13)
        $this.search(0);
    }, 1000);
  }

  cancel() {
    this.searchText = null;
    this.idDeliverySituation = null;
    this.selectedPeriod = null;
    this.search(0);
  }

  search(pageIndex: number) {
    // this.tableComponent?.setLoading(true);
    this.isLoading = true;
    this.listTicketLog = null;
    this.listTriageLog = null;

    if (this.selectedPeriod instanceof Date)
      this.selectedPeriod.setHours(0, 0, 0, 0);

    let request = {
      datetimeInitRequest: this.selectedPeriod,
      searchText: this.searchText,
      idHealthUnit: this.idHealthUnit,
      pageIndex: pageIndex,
      idDeliverySituation: this.idDeliverySituation
    }

    this.requestLogService.search(request).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.listDeliverySituation = response?.listDeliverySituation;

        if (response?.logTicketTotemRequest?.listTicketTotemRequest?.length > 0) {

          this.fullListSizeTicket = response.logTicketTotemRequest.fullListSize;
          this.listTicketLog = this.transformToTableRows(response.logTicketTotemRequest.listTicketTotemRequest);
        }
        else {
          this.listTicketLog = null;
          this.fullListSizeTicket = 0;
        }

        if (response?.logTriageRequest?.listTriageRequest?.length > 0) {

          this.fullListSizeTriage = response.logTriageRequest.fullListSize;
          this.listTriageLog = this.transformToTableRows(response.logTriageRequest.listTriageRequest);
        }
        else {
          this.listTriageLog = null;
          this.fullListSizeTriage = 0;
        }

        this.isLoading = false;
        // this.tableComponent?.setLoading(false);
      },
      error: (error) => {
        console.log(error);
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this.isLoading = false;
      }
    });
  }

  logDetails(event: any) {
    let numberOfLinesInTextPatientExitLog = this.countLinesInArea(event.requestBody, 825, 16);
    const dialogRef = this.dialog.open(LogDetailsModalComponent, {
      panelClass: 'custom-dialog-class',
      height: '90vh',
      disableClose: true,
      data: {
        logRequestDetails: event.requestBody,
        logResponseDetails: event.xmlResponse,
        numberOfLinesInTextPatientExitLog
      }
    });
    dialogRef.afterClosed().subscribe({
      next: result => {
      }
    });
  }

  countLinesInArea(text: string, areaWidth: number, fontSize: number): number {
    if (!text || text.trim() === "")
      return 0;

    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (!context) return 0;

    context.font = `${fontSize}px Arial`;

    const words = text.split(' ');
    let lineWidth = 0;
    let lines = 1;

    for (const word of words) {
      const wordWidth = context.measureText(word + ' ').width;
      if (lineWidth + wordWidth > areaWidth) {
        lines++;
        lineWidth = wordWidth; // Começa uma nova linha
      }
      else
        lineWidth += wordWidth;
    }

    return lines;
  }

  transformToTableRows(listLog: TicketTotemRequestModel[] | TriageRequestModel[]) {
    return listLog.map(log => {
      return {
        deliverySituationDescription: this.listDeliverySituation?.find(x => x.idDeliverySituation == log.idDeliverySituation)?.description,
        datetimeInclusion: log.datetimeInclusion,
        idHealthUnit: log.idHealthUnit,
        requestBody: log.requestBody,
        xmlResponse: log.xmlResponse,
        proccessCount: log.proccessCount,
        cnesProvider: log.cnesProvider,
        deliveryGuid: log.deliveryGuid,
        datetimeVerification: log.datetimeVerification,
        idEpisode: log.idEpisode
      };
    });
  }
}